// src/components/certificacion/CertificacionDashboard.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  Box, Typography, Button, CircularProgress, Paper,
} from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { certificacionService } from '../../services/certificacionService';
import CertificacionDetalle from './CertificacionDetalle';
import CertificacionIniciar from './CertificacionIniciar';

export default function CertificacionDashboard() {
  const empresaActiva = useSelector(state => state.empresa.empresaActiva);
  const [tieneCertificacion, setTieneCertificacion] = useState(null); // null=cargando, true/false
  const [modalIniciar, setModalIniciar] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);

  const rutCompleto = empresaActiva
    ? `${empresaActiva.rut}-${empresaActiva.dv}`
    : null;

  const verificarExistencia = useCallback(async () => {
    if (!rutCompleto) {
      setTieneCertificacion(false);
      return;
    }
    setCheckLoading(true);
    try {
      await certificacionService.getEstado(rutCompleto);
      setTieneCertificacion(true);
    } catch (err) {
      const msg = err?.message || '';
      if (msg.includes('404')) {
        setTieneCertificacion(false);
      } else {
        setTieneCertificacion(false);
      }
    } finally {
      setCheckLoading(false);
    }
  }, [rutCompleto]);

  useEffect(() => {
    verificarExistencia();
  }, [verificarExistencia]);

  const handleCreated = () => {
    setTieneCertificacion(true);
  };

  return (
    <Box>
      {/* Cabecera */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Certificación DTE
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => setModalIniciar(true)}
          size="small"
        >
          Nueva
        </Button>
      </Box>

      {/* Contenido */}
      {!empresaActiva ? (
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">
            Selecciona una empresa para ver su certificación.
          </Typography>
        </Paper>
      ) : checkLoading || tieneCertificacion === null ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : tieneCertificacion ? (
        <CertificacionDetalle rutEmpresa={rutCompleto} />
      ) : (
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            La empresa <strong>{rutCompleto}</strong> no tiene un proceso de certificación activo.
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={() => setModalIniciar(true)}
          >
            Iniciar certificación
          </Button>
        </Paper>
      )}

      <CertificacionIniciar
        open={modalIniciar}
        onClose={() => setModalIniciar(false)}
        onCreated={handleCreated}
      />
    </Box>
  );
}
